var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "information" },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.listNumber") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.flowNum))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "问题发生地" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.eventalSite))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "联系人" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.contact))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.contactNumber") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.phone))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "投诉内容" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.complaintContent))])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h3", { staticStyle: { "padding-bottom": "10px" } }, [
        _vm._v("服务派工")
      ]),
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dispatchData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.appointTo"),
                        prop: "repairUserList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          options: _vm.options,
                          props: _vm.propstree,
                          placeholder: "请选择派工人员"
                        },
                        model: {
                          value: _vm.dispatchData.repairUserList,
                          callback: function($$v) {
                            _vm.$set(_vm.dispatchData, "repairUserList", $$v)
                          },
                          expression: "dispatchData.repairUserList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.sendExtandRemark") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "670px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.dispatchData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.dispatchData, "remark", $$v)
                          },
                          expression: "dispatchData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handDispatch } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }